import React from "react";
import { Tooltip, Typography, Zoom } from "@mui/material";
import { Info } from "@mui/icons-material";

export default function InfoTooltip(props) {
  const { tipsInfo, fontSize = 14 } = props;

  return (
    <Tooltip
      title={tipsInfo.map((tipInfo) => (
        <div key={tipInfo.title}>
          <Typography>{tipInfo.title}</Typography>
          <Typography sx={{ fontSize: 13 }}>{tipInfo.description}</Typography>
          <br />
        </div>
      ))}
      arrow
      placement={"right"}
      TransitionComponent={Zoom}
      className="custom-tooltip"
    >
      <Info sx={{ fontSize: fontSize }} />
    </Tooltip>
  );
}
